<template>
    <div class="configurator-bike-picture mt-4 mb-4" v-if="url">
        <v-lazy-image :src="url" />
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";

    export default {
        name: 'BikePicture',
        props: {
            url: String
        },
        components: {
            VLazyImage
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .configurator-bike-picture {
        text-align: center;
        width: 100%;
    }
    .v-lazy-image {
        opacity: 0;
        transition: opacity 2s;
        width: 100%;
    }
    .v-lazy-image-loaded {
        opacity: 1;
    }
    @media (min-width: 768px) {
        .configurator-bike-picture {
            max-width: 600px;
            margin: 0 auto;
        }
    }
</style>